import ko from '@tko/build.knockout';
import DomPurify from 'dompurify';

ko.bindingHandlers.htmlSafe = {
    update: function(element, valueAccessor) {
        let value = valueAccessor();
        let valueUnwrapped = ko.unwrap(value);
        let sanitizedValue = DomPurify.sanitize(valueUnwrapped);
        $(element).html(sanitizedValue);
    }
};
